const ACTION = {
  SET_INSIGHTS_ORDER: "SET_INSIGHTS_ORDER",
  HIGHLIGHT_IN_VISUALIZSER: "HIGHLIGHT_IN_VISUALIZSER",
};

export { ACTION };
